module.exports = __webpack_public_path__ + "static/media/ios-car.84545fdd.svg";